/** https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript */
export const getParameterByName = (name, url = window.location.href) => {
    const regex = new RegExp('[?&]' + name.replace(/[\[\]]/g, '\\$&') + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
//# sourceMappingURL=parse.url.js.map